import React from 'react'
import { MetabaseModuleDashboardEmbedUrlQuery } from '../__gen'
import style from './index.module.sass'

type Props = {
	dashboard: {
		embedUrl: string
	}
}

export const MetabaseIframe = (props: Props) => {
	return (
		<>
			<div className={style.topSpacer}></div>
			<div className={style.container}>
				{props.dashboard.embedUrl ?
					<iframe src={props.dashboard.embedUrl} className={style.iframe} />
				:	<div>Error loading embed URL</div>}
			</div>
		</>
	)
}
